import React from 'react';
import clsx from 'clsx';
import { TitleImage } from '../AboutPageGeneralComp';

/**
 * This component is used in markdown component that is rendered in aboutPage page.
 * It contains info about how to add blocks to a new page.
 */
const AddingBlocksToNewPage = ({elSubRefs}) => (
    <div id="Group8Sub11" ref ={elSubRefs[10]} className={clsx("subgroup")}>
        <h4 id="Group8Sub11">Adding blocks to your new page</h4>
        {/**
         * Every TitleImage component contains an image and a title.Title describes the image.
         */}
        <TitleImage 
            title='You can now add a Navbar and a Breadcrumb as in the previous page.'
            srcImg='/images/AboutPageMarkdownImg/20.jpg'
        />
        <TitleImage 
            title='Add a "1 Column" block element.'
            srcImg='/images/AboutPageMarkdownImg/21.jpg'
        />
        <TitleImage 
            title='Add a "Text section" block element.'
            srcImg='/images/AboutPageMarkdownImg/22.jpg'
        />
        <TitleImage 
            title='Add an "Image" block element.'
            srcImg='/images/AboutPageMarkdownImg/23.jpg'
        />
        <TitleImage 
            title='Edit your block elements (e.g. texts).'
            srcImg='/images/AboutPageMarkdownImg/24.jpg'
        />
        <TitleImage 
            title='Duplicate some elements to add more information to your page.'
            srcImg='/images/AboutPageMarkdownImg/25.jpg'
        />   
        <TitleImage 
            title='Add a "Tabs" block element.'
            srcImg='/images/AboutPageMarkdownImg/26.jpg'
        />         
        <TitleImage 
            title='Edit the content of your Tabs.'
            srcImg='/images/AboutPageMarkdownImg/27.jpg'
        />           
    </div>
)

export default AddingBlocksToNewPage;